//Generated File 
export const ANALYSIS_SET = `an`;
export const BRANCH = `br`;
export const DEPARTMENT = `dep`;
export const LEGAL_ENTITY = `leg`;
export const LOGIN_ID = `lId`;
export const PASSWORD = `p`;
export const SECTOR = `sc`;
export const USER_ID = `uId`;
